import "../Breadcumb/Breadcrumb.css";
import React, { useState } from "react";
import Modal from 'react-modal';
import CreateTaskManagerModal from "../CreateBookingManagerModal";
import { useTranslation } from 'react-i18next';

const Breadcrumb = ({ onViewChange, selected, api }) => {
  Modal.setAppElement('#root');

  const handleButtonClick = (view) => {
    onViewChange(view);
  };

  const { t } = useTranslation(['dashboard']);

  return (
    <>
      <div className="bloc-search background-breadcrumb">
        <div className="container">
          <div className="search">
            <div className='breadcrumb-navigation'>
              <button
                className={`breadcrumb-map-button ${selected === 'map' ? 'active' : ''}`}
                onClick={() => handleButtonClick('map')}
              >
                <div className={`icon ${selected === 'map' ? 'active-icon' : ''}`} />
                <span className='breadcrumb-label'>{t('list')}</span>
              </button>

              <button
                className={`breadcrumb-list-button ${selected === 'list' ? 'active' : ''}`}
                onClick={() => handleButtonClick('list')}
              >
                <div className={`icon ${selected === 'list' ? 'active-icon' : ''}`} />
                <span className='breadcrumb-label-list'>{t('map')}</span>
              </button>
            </div>
          </div>
          {selected === "map" && <CreateTaskManagerModal api={api} />}
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
